import CheckListFormComponent from "components/shared/FormComponent/CheckListFormComponent";
import StyledButton from "components/shared/StyledButton";
import { Body, Heading2, TinyBody } from "helpers/TypographyComponents";
import { nameTransform } from "helpers/utils";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import type { TFormCreateAgreement, TTitleBeneficiaries } from "../utils";
import styles from "./style.module.scss";

interface IBeneficiariesStep {
    handleNextStep: () => void;
    titleBeneficiaries: TTitleBeneficiaries;
    onClose: () => void;
    defaultBeneficiaryId: number;
    onPrevious?: () => void;
}

const BeneficiariesStep = ({
    handleNextStep,
    titleBeneficiaries,
    onClose,
    defaultBeneficiaryId,
    onPrevious,
}: IBeneficiariesStep) => {
    const [t] = useTranslation();
    const { control, watch } = useFormContext<TFormCreateAgreement>();

    const renderOptionLabel = (id: number) => {
        const beneficiary = titleBeneficiaries.beneficiary[id];
        return (
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "0.5rem",
                    width: "100%",
                }}
            >
                <Body>{beneficiary.name ?? ""}</Body>
                {beneficiary.representative && (
                    <TinyBody color="grey">
                        {t("ContractValidation.RepresentedBy")} {nameTransform(beneficiary.representative)}
                    </TinyBody>
                )}
            </div>
        );
    };
    return (
        <div className={styles["agreement-validation-modal-authors"]}>
            <div className={styles["agreement-validation-modal-authors-wrapper"]}>
                <Heading2>{t("ContractValidation.ChooseBeneficiaries")}</Heading2>
                <Body color="info">{t("ContractValidation.GeneratedContractIncludes")}</Body>
                <div className={styles["agreement-validation-modal-authors-body"]}>
                    <div className={styles["agreement-validation-modal-authors-info"]}>
                        <Body color="grey">{t("ContractValidation.BeneficiariesSignatories")}</Body>
                        <Body color="grey">{t("ContractValidation.AuthorsOnDocument")}</Body>
                    </div>
                    <CheckListFormComponent
                        control={control}
                        controlName="beneficiaryIds"
                        label={t("ContractValidation.Signatories")}
                        options={titleBeneficiaries.options}
                        labelInfo={`(${t("ContractValidation.Beneficiaries")})`}
                        sx={{ display: "flex", justifyContent: "center" }}
                        disabledOptions={[defaultBeneficiaryId]}
                        renderOptionLabel={(id) => renderOptionLabel(id)}
                        fullWidth
                        maxHeight="10rem"
                    />
                </div>
            </div>
            <div className={styles["agreement-validation-modal-authors-actions"]}>
                <div style={{ display: "flex", gap: 8 }}>
                    <StyledButton buttonType="secondary" onClick={onClose}>
                        {t("Cancel")}
                    </StyledButton>
                    {onPrevious && (
                        <StyledButton buttonType="secondary" onClick={onPrevious}>
                            {t("NewElement.Previous")}
                        </StyledButton>
                    )}
                </div>
                <StyledButton buttonType="primary" onClick={handleNextStep}>
                    {t("NewElement.Continue")}
                </StyledButton>
            </div>
        </div>
    );
};

export default BeneficiariesStep;
